import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { serialNumbersService } from 'services';
import { ROUTES } from 'constants/routes';
import { CustomButton, Spinner } from 'components';

import './RegistrationHistory.scss';
import { SerialNumber } from '../../interfaces/serialNumber';
import { REGISTRATION_HISTORY_FIELDS } from '../../constants/serialNumbersListFields';

export const RegistrationHistory = () => {
  const [serialsList, setSerialsList] = useState<[] | SerialNumber[]>([]);
  const [isListLoading, setIsListLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsListLoading(true);

      try {
        const response = await serialNumbersService.getRegistrationHistory();
        if (response) {
          setIsListLoading(false);
          setSerialsList(response);
        }
      } catch (e) {
        setIsListLoading(false);
      }
    })();
  }, []);

  async function downloadExcel() {
    const response = await serialNumbersService.getRegistrationHistoryExcel();
    const fileURL = window.URL.createObjectURL(response as Blob);
    const alink = document.createElement('a');
    alink.href = fileURL;
    alink.download = `Registration_History_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`;
    alink.click();
  }

  return (
    <div className="registration-history-container">
      <div className="registration-history__header-box">
        <h6 className="registration-history__header">Registration History</h6>
        <div>
          <CustomButton
            height="40px"
            text="Export to Excel"
            onClick={() => downloadExcel()}
          />
        </div>
      </div>
      <div className="registration-history__fields">
        {REGISTRATION_HISTORY_FIELDS.map(({ name }) => (
          <div key={name} className="registration-history__field">
            <p className="registration-history__text">{name}</p>
          </div>
        ))}
      </div>
      <div className="registration-history__data-container">
        {serialsList.length !== 0 &&
          !isListLoading &&
          serialsList.map(
            ({
              sn,
              sn_partner,
              id_code,
              imo_nr,
              schiffsname,
              commissioning_date,
              validity,
              last_external_calibration,
            }) => (
              <div key={sn} className="registration-history__data-box">
                <p className="registration-history__data-item">{sn}</p>
                <p className="registration-history__data-item">{sn_partner}</p>
                <p className="registration-history__data-item">{id_code}</p>
                <p className="registration-history__data-item">{imo_nr}</p>
                <p className="registration-history__data-item">{schiffsname}</p>
                <p className="registration-history__data-item">
                  {commissioning_date}
                </p>
                <p className="registration-history__data-item">{validity}</p>
                <p className="registration-history__data-item">
                  {last_external_calibration}
                </p>
                <p className="registration-history__data-item">
                  <span
                    onClick={() =>
                      navigate(`${ROUTES.documents_overview}/${sn}`)
                    }
                  >
                    Details
                  </span>
                </p>
              </div>
            )
          )}
        {!serialsList.length && !isListLoading && (
          <div className="registration-history__empty">
            Your registration history is empty
          </div>
        )}
        {isListLoading && (
          <div className="registration-history__spinner-box">
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};
